
//Heads up, this overlaps w/ an existing airframe component, that is all
import React from 'react';
import cn from 'classnames';

import styles from './radioButton.module.css';

export type RadioButtonOption = {
  name: string,
  value: any,
};

type RadioButtonProps = {
  label: string,
  value: any,
  checked: boolean,
  fieldName: string,
  onChange: (value: any) => void;
  styles?: string[] | string,
};

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  value,
  checked,
  fieldName,
  onChange,
  styles: propStyles,
}) => {
  const id = `${fieldName}-${value}`;
  return (
    <>
      <div className={cn(propStyles)}>
        <input
          id={id}
          type="radio"
          //FYI, the below 'styles' is from the above import, NOT from the above props.styles... super different. carry on.
          className={cn(styles.radioButtonInput)}
          name={fieldName}
          value={value}
          checked={checked}
          onChange={() => onChange(value)}
        />
        <label htmlFor={`${id}`} className={cn(styles.label)}>
          {label}
        </label>
      </div>
    </>
  );
};

type RadioButtonGroupStyles = {
  wrapperStyles?: string[],
  optionStyles?: string[],
};

type RadioButtonGroupProps = {
  id: string,
  options: RadioButtonOption[],
  value?: any,
  field: string,
  onChange: (value: any) => void;
  styles: RadioButtonGroupStyles,
};

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  id,
  options,
  value: propValue,
  field,
  onChange,
  styles: groupStyles,
}) => (
  <div
  id={id}
    key={field}
    className={cn(groupStyles.wrapperStyles, styles.option)}
  >
    {options.map((option, index) => {
      //this optionClassNames mess is because if you just toss the passed array of classname strings in to cn,
      //  they go directly on the component, but the build doesn't see those classnames being referenced, so culls
      //  the class style definition from the CSS, so this replaces any classname strings passed in, w/ references
      //  to their imported CSS class definition, and leaves any other classnames alone, b/c that's how it was when I got here.
      const optionClassNames = cn(
        groupStyles?.optionStyles?.map(style => {
          return style in styles ? styles[style] : style;
        }),
      );
      const { name, value } = option;
      return (
        <RadioButton
          key={`${name}-${index}`}
          label={name}
          value={value}
          checked={propValue === value}
          fieldName={field}
          onChange={onChange}
          styles={optionClassNames}
        />
      );
    })}
  </div>
);

export default RadioButton;
